
import React, { useState } from 'react';
import PageBox from '../../components/PageBox';
import ProTitle from '../../components/ProTitle';
import { Anchor,Carousel } from 'antd';
import { RightOutlined } from '@ant-design/icons';
import './index.less'
import valuebg1 from "../../static/images/valuebg1.png"
import valuebg3 from "../../static/images/valuebg3.png"
import zixun from "../../static/images/zixun.png"
import valuebg6 from "../../static/images/valuebg6.png"
const imageNumbers = Array.from({ length: 10 }, (_, i) => i + 1);

// 动态导入所有图片，生成图片路径数组
const images = imageNumbers.map((num) => {
  return require(`../../static/images/yy${num}.png`);
});
export default function App() {
  const memo = '作为智能化转型的"数字引擎"，云产品与服务通过技术融合构建多元能力，以"一云多算"实现智能、高性能、通用算力的融合调度，结合云卓越架构与全链路安全体系，满足用户智能化需求  '
  const memoa= '覆盖10大企业应用领域，适应企业数智化业务融合发展要求'
  const memob =''
  const item =[
    {title:'云订阅', key:'part-1', href:'#part-1',},
    {title:'专属云', key:'part-2', href:'#part-2',},
    {title:'本地化部署', key:'part-3', href:'#part-3',},
    {title:'运维运营服务', key:'part-4', href:'#part-4',},
    {title:'咨询服务', key:'part-5', href:'#part-5',},
    {title:'用友云产品', key:'part-6', href:'#part-6',},
  ]
  const yongyou=[
    {name:'财务云', link:'https://www.yonyou.com/subject/caiwu?zixun=0&withYonyouMenu'},
    {name:'人力云', link:'https://www.yonyou.com/subject/yy-rl-dhr?zixun=0&withYonyouMenu'},
    {name:'供应链云', link:'https://www.yonyou.com/subject/szgyl?zixun=0&withYonyouMenu'},
    {name:'营销云', link:'https://www.yonyou.com/subject/yingxiao?zixun=0&withYonyouMenu'},
    {name:'采购云', link:'https://www.yonyou.com/subject/caigou-liucheng?zixun=0&withYonyouMenu'},
    {name:'制造云', link:'https://www.yonyou.com/subject/zhizaoyun?zixun=0&withYonyouMenu'},
    {name:'研发云', link:'https://www.yonyou.com/subject/yanfayu?zixun=0&withYonyouMenu'},
    {name:'项目云', link:'https://www.yonyou.com/subject/xmy?zixun=0&withYonyouMenu'},
    {name:'资产云', link:'https://www.yonyou.com/subject/szzc?zixun=0&withYonyouMenu'},
    {name:'协同云', link:'https://www.yonyou.com/subject/gd-xietong?zixun=0&withYonyouMenu'},
  ]
  const [top, setTop] = useState(70);
  const onChange = (currentSlide) => {
    console.log(currentSlide);
  };
  return (
    <>
      <PageBox useBanner={true}>
        <div className='cloudBanner'></div>
        <ProTitle name={'云产品与服务'} memo={memo} />
        <div className='cloudmodel'>
          <Anchor offsetTop={top} direction="horizontal" items={item} />
        </div>
        <div className='huisebg' id="part-1">
          <div className='cloudRecord'>
            <div><img src={valuebg1} /></div>
            <div className='context'>
              <h3>云订阅</h3>
              <div className='text'>云订阅服务以 “轻量化接入、全周期服务、灵活付费” 为核心，用户无需关注底层硬件维护、系统升级与技术运维，只需根据业务需求选择对应套餐（按年 / 按季 / 按月订阅），即可快速获取稳定、安全的云端服务。同时，服务支持 “按需扩容 / 缩容”，用户可根据业务增长或需求变化调整订阅内容，避免资源浪费，降低数字化门槛。</div>
              <ul>
                <li>
                  <h3>全周期服务保障</h3>
                  <div>服务商负责底层硬件维护、系统漏洞修复、软件版本更新，用户无需投入技术团队，降低运维成本</div>
                </li>
                {/* <li className='list'>
                  <h3>数据安全与合规</h3>
                  <div>服务符合国家网络安全法、数据保护条例及行业合规标准，确保用户满足合规要求；内置数据加密、访问权限控制、备份与恢复功能，保障数据不泄露、不丢失</div>
                </li> */}
                <li className='list'>
                  <h3>分层订阅与灵活付费</h3>
                  <div>提供基础版、专业版等分层套餐，覆盖不同用户需求，套餐内容清晰可查；支持按年、按季、按月订阅，部分服务提供 “按量付费” 补充方案（如临时增加存储容量），满足短期或突发需求，降低前期投入成本</div>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div className='baise' id="part-2">
          <div className='zhusnshu'>
            <div className='context'>
              <h3>专属云</h3>
              <div className='text'>专属云服务以“专属资源池+全托管运维+行业深度适配”为核心，为客户提供从底层基础设施到上层应用的端到端解决方案。其核心价值体现在三方面</div>
              <ul>
                <li>
                  <h3>分级隔离与安全防护体系</h3>
                  <div>基于角色的访问控制（RBAC）、IP白名单、操作审计日志等功能，实现对资源访问的全生命周期监管</div>
                </li>
                <li className='list'>
                  <h3>合规适配与国产化支持</h3>
                  <div>采用自研云平台、国产操作系统与数据库（如政务云场景），实现自主可控、安全可信</div>
                </li>
                <li>
                  <h3>全托管运维与高可用保障</h3>
                  <div>配备行业技术团队与安全运维团队，提供工单、电话、远程协助等多渠道支持</div>
                </li>
              </ul>
            </div>
            <div><img src={valuebg3} /></div>
          </div>
        </div>
        <div className='huisebg'  id="part-3">
          <div className='valueBox'>
            <div><img src={valuebg6} /></div>
            <div className='context'>
              <h3>本地化部署</h3>
              <div className='text'>本地化部署服务是为对数据安全、系统可控性有高要求的客户提供的专属部署方案，将招采相关系统（如平台、数据库、应用程序）直接搭建在客户自有服务器或指定私有环境中，而非依赖公有云，核心解决数据隐私保护与业务自主管控需求；提供本地化运维支持，包括系统监控、故障排查、版本更新；支持客户根据业务需求自主调整功能模块，迭代速度与方向完全由客户掌控</div>
            </div>
          </div>
        </div>
        <div className='baise' id="part-4">
          <div className='valueBox'>
            <div className='context'>
              <h3>运营运维服务</h3>
              <div className='text'>为招标采购全流程提供的专业支撑服务，聚焦系统稳定运行与业务效能提升；涵盖招采平台日常运维、故障快速响应、性能优化，以及从需求分析到方案落地的全周期咨询，助力客户招采系统高效、安全、合规运转</div>
            </div>
            <div className='lvyue'></div>
          </div>
        </div>
        <div className='huisebg' id="part-5">
          <div className='valueBox'>
            <div><img src={zixun} /></div>
            <div className='context'>
              <h3>咨询服务</h3>
              <div className='text'>全托管运维+我们聚焦全流程服务支持，为客户提供从项目启动到落地运营的一站式解决方案</div>
              <ul className='zixunBox'>
                <li>
                  <h3>项目全过程咨询</h3>
                  <p>覆盖项目全生命周期，提供专业规划与执行指导，保障项目高效推进</p>
                </li>
                <li className='list'>
                  <h3>可行性研究报告</h3>
                  <p>基于详实分析，出具全面的项目可行性评估，为决策提供科学依据</p>
                </li>
                <li>
                  <h3>市场调研</h3>
                  <p>精准洞察市场趋势、需求与竞争格局，为项目定位与策略制定奠定基础</p>
                </li>
                <li>
                  <h3>运营咨询服务</h3>
                  <p>优化运营模式与流程，提升运营效率与效益，助力业务稳步发展</p>
                </li>
                <li className='list'>
                  <h3>招标代理服务</h3>
                  <p>规范招标流程，保障采购公平公正，降低项目采购风险</p>
                </li>
                <li>
                  <h3>软件技术服务</h3>
                  <p>提供定制化软件技术支持，涵盖开发、运维等，赋能数字化转型</p>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div className='baise' id="part-6">
          <div className='yongyou'>
            <ProTitle name={'用友云产品'} memo={memoa} />
            <div className='yongyou-con'>
              <Carousel afterChange={onChange}>
                {/* <div>
                  <h3>5646465465465456</h3>
                </div> */}
              {yongyou.map((item,index) => 
                <div key={index} className='yongyou-list' >
                  <div className='yongyou-text' style={{background:'URL(' + `${images[index]}` + ') no-repeat top center'}}>
                    <div className='yongyou-link'>
                      <a href={item.link} target='_blank'>了解详情 <RightOutlined /></a>
                    </div>
                  </div>
                </div>
                )}
              </Carousel>
            </div>
            
          </div>
        </div>
      </PageBox>
    </>
    
  );
}
